// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custBtn {
    background-color: #fc9700ec!important;
    color: White !important;
    /* color: White !important; */
    /* color: #ff9800 !important; */
    /* padding: 10px 20px !important; */
    border: none !important;
    border-radius: 5px !important;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
    transition: background-color 0.3s, box-shadow 0.3s !important;
  }
  
  .custBtn:hover {
    background-color: #fcb03eec !important;
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2) !important;
    transform: translateY(-1px);
  }
  
  .customShadow{
    /* padding: 20px;padding-bottom: 10px; */
    box-sizing: border-box;
    border-radius: 10px;
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.3) , 0 -6px 8px rgba(0, 0, 0, 0.1);
  }
  .custom_input {
    box-shadow: 5px 5px 7px -1px #d3d3d3;
}
.formContainer{
  border: 2px solid #17263948;
}

.cardTitle{
  color: var(--secondary-color);
  font-size: 14px;
}
.cardContent{
  font-size: 13px;
  color: rgb(95, 95, 95);
  
}
.dottedBorder{
  border-right: 1px solid var(--primary-color);;
}
`, "",{"version":3,"sources":["webpack://./src/pages/arbitrator/Arbitrator.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,uBAAuB;IACvB,6BAA6B;IAC7B,+BAA+B;IAC/B,mCAAmC;IACnC,uBAAuB;IACvB,6BAA6B;IAC7B,mDAAmD;IACnD,6DAA6D;EAC/D;;EAEA;IACE,sCAAsC;IACtC,mDAAmD;IACnD,2BAA2B;EAC7B;;EAEA;IACE,wCAAwC;IACxC,sBAAsB;IACtB,mBAAmB;IACnB,wEAAwE;EAC1E;EACA;IACE,oCAAoC;AACxC;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,eAAe;EACf,sBAAsB;;AAExB;AACA;EACE,4CAA4C;AAC9C","sourcesContent":[".custBtn {\n    background-color: #fc9700ec!important;\n    color: White !important;\n    /* color: White !important; */\n    /* color: #ff9800 !important; */\n    /* padding: 10px 20px !important; */\n    border: none !important;\n    border-radius: 5px !important;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;\n    transition: background-color 0.3s, box-shadow 0.3s !important;\n  }\n  \n  .custBtn:hover {\n    background-color: #fcb03eec !important;\n    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2) !important;\n    transform: translateY(-1px);\n  }\n  \n  .customShadow{\n    /* padding: 20px;padding-bottom: 10px; */\n    box-sizing: border-box;\n    border-radius: 10px;\n    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.3) , 0 -6px 8px rgba(0, 0, 0, 0.1);\n  }\n  .custom_input {\n    box-shadow: 5px 5px 7px -1px #d3d3d3;\n}\n.formContainer{\n  border: 2px solid #17263948;\n}\n\n.cardTitle{\n  color: var(--secondary-color);\n  font-size: 14px;\n}\n.cardContent{\n  font-size: 13px;\n  color: rgb(95, 95, 95);\n  \n}\n.dottedBorder{\n  border-right: 1px solid var(--primary-color);;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
